import {Component} from "@angular/core";
import {AbstractView} from "../../../views/AbstractView";

@Component({
  selector: 'link-not-found',
  templateUrl: './not-found.view.html',
  styleUrls: ['./not-found.view.scss']
})
export class NotFoundView extends AbstractView<any> {

  constructor() {
    super();
  }
}
